import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, IconButton, Avatar, Box } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    margin: '0px 5px'
  },
  imageContainer: {
    cursor: 'pointer',
    backgroundColor: '#fff',
    width: 75,
    height: 75,
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  image: {
    height: 75,
    width: 75,
    border: '2px solid #ec8181',
    cursor: 'pointer'
  },
  username: {
    fontSize: 12,
    color: 'black',
    marginTop: '5px'
  }
}));

export const CircleStory = ({ baseImage, username, handleClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Avatar alt="ikram" className={classes.image} onClick={handleClick} src={baseImage} />
      <div className={classes.username}>
        <Typography variant="body2" className={classes.username}>
          {username}
        </Typography>
      </div>
    </div>
  );
};
